<template>

  <div class="row" ref="ForumForm">

    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <div class="col-12">
          <div class="card card-wizard" id="wizardCard">
            <form-wizard shape="tab"
                         :title="formTitle"
                         :subtitle="''"
                         error-color="#FB404B"
                         color="#35495E"
                         ref="itemWizard">
              <tab-content title="English Content"
                           class="col-12"
                           icon="nc-icon nc-map-big"
                           :before-change="() => validateStep('englishStep')">
                <english-step :formData="formData ? formData['en'] : defaultFormData['en']"
                              :editMode="editMode"
                              :builderData="builderData"
                              :key="stepKey"
                              ref="englishStep"
                              @on-validated="onStepValidated" @submit-step="submitStep"></english-step>
              </tab-content>
              <tab-content v-for="(lang, index) in languageList" :key="index" :title="lang.label+' Content'"
                           class="col-12"
                           icon="nc-icon nc-map-big"
                           :before-change="() => validateStep(lang.value)">
                <other-languages-step
                  :formData="formData ? formData[lang.value] : defaultFormData[lang.value]"
                  :editMode="editMode"
                  :isSubmit="languageList.length - 1 === index"
                  :lang="lang" :ref="lang.value" @on-validated="onStepValidated"
                  @submit-step="submitStep"></other-languages-step>
              </tab-content>

              <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Back</button>
              <button slot="next" class="btn btn-default btn-fill btn-wd btn-next">Next</button>
              <button slot="finish" class="btn btn-success btn-fill btn-wd" :disabled="entityNotFoundError || submitting">Finish</button>
            </form-wizard>
          </div>
        </div>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import {extend} from "vee-validate";
import {mapGetters} from "vuex";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import EnglishStep from "./Wizard/EnglishStep";
import OtherLanguagesStep from "./Wizard/OtherLanguagesStep";


extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    FormWizard,
    TabContent,
    OtherLanguagesStep,
    EnglishStep,
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,

      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {},
      defaultFormData: {
        title: "",
        date: "",
        location: "",
        image: "",
        is_active: true,
        is_utc_time: true,
        is_current: false,
        speakers: [],
      },
      builderData: {
        speakersList: []
      },
      wizardModel: {},
      stepKey: 0,

    };
  },
  computed: {
    ...mapGetters({
      languageList: "global/languageList"
    })
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.forumForm
    });
    this.setNullFormData();

    let data = {}
    this.axios.post("forums/builder", data).then((response) => {
      this.builderData.speakersList = response.data.speakers;
      this.builderData.localHostsList = response.data.localHosts;
      this.builderData.organizersList = response.data.organizers;
      this.builderData.sponsorsList = response.data.sponsors;

      this.id = this.$route.params['id'];

      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Forum";
        this.getForum();
      } else {
        this.editMode = false;
        this.formTitle = "Add Forum";
        this.loader.hide();
      }
    }).catch((error) => {
      console.error(error);
    })
  },
  methods: {
    getForum() {
      let data = {
        'id': this.id,
      };
      this.axios.post("forums/get", data).then((response) => {
        this.formData = response.data;
        this.formData['en'].speakers = response.data['en'].speakers.map(speaker => speaker.id);
        this.formData['en'].organizers = response.data['en'].organizers.map(organizer => organizer.id);
        this.formData['en'].local_hosts = response.data['en'].local_hosts.map(local_host => local_host.id);
        this.formData['en'].sponsors = response.data['en'].sponsors.map(sponsor => sponsor.id);
        this.vueDate();
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Forum Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;
      this.laravelDate();
      if (this.editMode === true) {
        request = this.axios.put("forums/update/" + this.id, this.formData);
        successMessage = "Forum Updated Successfully";
      } else {
        request = this.axios.post("forums/create", this.formData);
        successMessage = "Forum Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/forums/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
          this.$refs.itemWizard.navigateToTab(0);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    validateStep(ref) {
      if (Array.isArray(this.$refs[ref])){
        return this.$refs[ref][0].validate();
      }else{
        return this.$refs[ref].validate();
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = {...this.wizardModel, ...model}
    },
    submitStep(data, lang, isSubmit){
      this.formData[lang] = data;
      if (isSubmit){
        this.submit();
      }
    },
    setNullFormData(){
      this.defaultFormData['en'] = {
      };
      this.languageList.forEach(lang => {
        this.defaultFormData[lang] = {
        }
      })
    },
    vueDate() {
      this.formData['en'].date = (this.formData['en'].date) ? this.formData['en'].date.replace(' ', 'T') : this.formData['en'].date;
    },
    laravelDate() {
      this.formData['en'].date = (this.formData['en'].date) ? this.formData['en'].date.replace('T', ' ') : this.formData['en'].date;
    },
  }
}
</script>
